export class TimeStampModel {
  public hours: number;
  public minutes: number;
  public seconds: number;
  public millis: number;
}
